export default {
  pillars: `/v1/pillars/pillars`,
  pillar: (id: string) => `/api/v1/pillars/pillars/${id}`,
  steps: (pillar_id: string) => `/v1/pillars/steps?pillar_id=${pillar_id}`,
  step: (id: string) => `/v1/pillars/steps/${id}`
};
